// extracted by mini-css-extract-plugin
module.exports = {"styles":"InterstitialModal_styles__FRvoU"};